import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import useToastContext from "hooks/useToastContext";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useTranslation } from "react-i18next";

const NotificationAdd = ({
  getAllNotifications,
  handleCategory,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    // watch,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });
  const notification = useToastContext();
  const [addMerchantLoading, setAddMerchantLoading] = useState(false);

  const [sendToError, setSendToError] = useState(false);
  const [isAllUser, setIsAllUser] = useState(false);
  const [isAllFarmer, setIsAllFarmer] = useState(false);
  const [isAllInputRetailer, setIsAllInputRetailer] = useState(false);
  const [isAllLivestockSP, setIsAllLivestockSP] = useState(false);
  const [isAllAgriMachineSP, setIsAllAgriMachineSP] = useState(false);
  const [isAllOthers, setIsAllOthers] = useState(false);

  const onSubmit = async (data) => {
    try {
      if (
        !isAllUser &&
        !isAllFarmer &&
        !isAllInputRetailer &&
        !isAllLivestockSP &&
        !isAllAgriMachineSP &&
        !isAllOthers
      ) {
        setSendToError(true); 
        return
      } else {
        setSendToError(false);
      }
      const sendToArray = []
      if(isAllFarmer) sendToArray.push('farmer')
      if(isAllInputRetailer) sendToArray.push('inputRetailer')
      if(isAllLivestockSP) sendToArray.push('livestockServiceProvider')
      if(isAllAgriMachineSP) sendToArray.push('agriMachineryServiceProvider')
      if(isAllOthers) sendToArray.push('others')
      if(isAllUser) {
        sendToArray.length = 0
        sendToArray.push('all')
      }
      console.log('sendToArray: ', sendToArray);
      const obj = {
        title: data?.title,
        description: data?.description,
        sendTo: sendToArray,
      }
      const res = await apiPost(apiPath.notifications, {
        ...obj,
      });
      if (res.data.success) {
        handleCategory(false);
        notification.success(res?.data?.message);
        getAllNotifications();
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const onError = () => {
    if (
      isAllUser ||
      isAllOthers ||
      isAllAgriMachineSP ||
      isAllLivestockSP ||
      isAllInputRetailer ||
      isAllFarmer
    ) {
      setSendToError(false);
    } else {
      setSendToError(true);
    }
  };

  useEffect(() => {
    if (
      isAllUser ||
      isAllOthers ||
      isAllAgriMachineSP ||
      isAllLivestockSP ||
      isAllInputRetailer ||
      isAllFarmer
    ) {
      setSendToError(false);
    }
  }, [
    isAllUser,
    isAllOthers,
    isAllAgriMachineSP,
    isAllLivestockSP,
    isAllInputRetailer,
    isAllFarmer,
  ]);

  useEffect(() => {
    if(isAllUser) {
      setIsAllFarmer(true)
      setIsAllInputRetailer(true)
      setIsAllLivestockSP(true)
      setIsAllAgriMachineSP(true)
      setIsAllOthers(true)
    } else {
      setIsAllFarmer(false)
      setIsAllInputRetailer(false)
      setIsAllLivestockSP(false)
      setIsAllAgriMachineSP(false)
      setIsAllOthers(false)
    }
  },[isAllUser])

  return (
    <div>
      <>
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">
                    {t("ADD_NOTIFICATION")}
                  </h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => handleCategory(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-6 flex">
                  <div className="w-1/2">
                    <div className="px-2">
                      <div className="relative z-0 mb-6 w-full group">
                        <input
                          type="text"
                          name="title"
                          id="title"
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          maxLength={31}
                          {...register("title", {
                            required: t("VALIDATION_TITLE_REQUIRED"),
                            validate: (value) => {
                              const val = value.trim();
                              return val.length < 3
                                ? t("VALIDATION_TITLE_MIN_LENGTH")
                                : val.length > 30
                                ? t("VALIDATION_TITLE_MAX_LENGTH")
                                : true;
                            },
                          })}
                          onChange={(event) => {
                            var value = event.target.value;
                            value = value.trimStart();
                            setValue("title", value, { shouldValidate: true });
                          }}
                        />
                        <label
                          htmlFor="title"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("O_TITLE")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.title?.message} />
                      </div>
                    </div>
                    <div className="px-2">
                      <div className="relative z-0 mb-6 w-full group">
                        <textarea
                          type="text"
                          name="description"
                          id="description"
                          className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                          placeholder=" "
                          rows={7}
                          maxLength={256}
                          {...register("description", {
                            required: t("VALIDATION_DESCRIPTION_REQUIRED"),
                            validate: (value) => {
                              const val = value.trim();
                              return val.length < 3
                                ? t("VALIDATION_DESCRIPTION_MIN_LENGTH")
                                : true;
                            },
                          })}
                          onChange={(event) => {
                            var value = event.target.value;
                            value = value.trimStart();
                            setValue("description", value, {
                              shouldValidate: true,
                            });
                          }}
                        />
                        <label
                          htmlFor="description"
                          className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                          {t("O_MESSAGE")}
                          <span className="text-red-500">*</span>
                        </label>
                        <ErrorMessage message={errors?.description?.message} />
                      </div>
                    </div>
                  </div>
                  <div className="w-1/2">
                    <div className="px-2">
                      <div className="flex pb-2">
                        <h3 className="">{t("O_SEND_TO")}</h3>
                        <span className="text-red-500">*</span>
                      </div>
                      <div className="z-0 mb-6 w-full group grid grid-cols-2 gap-y-5">
                        <div className="flex items-center text-2xl">
                          <input
                            id="user-checkbox"
                            type="checkbox"
                            checked={isAllUser}
                            onChange={(e) => {
                              setIsAllUser(e.target.checked) 
                              e.target.checked ? setSendToError(false) : 
                              setTimeout(() => {
                                setSendToError(true)
                                }, 100)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="user-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Users
                          </label>
                        </div>
                        <div className="flex items-center mr-2 text-2xl">
                          <input
                            id="farmer-checkbox"
                            type="checkbox"
                            disabled={isAllUser}
                            checked={isAllFarmer}
                            onChange={(e) => {
                              setIsAllFarmer(e.target.checked) 
                              e.target.checked ? setSendToError(false) : setSendToError(true)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="farmer-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Farmers
                          </label>
                        </div>
                        <div className="flex items-center mr-2 text-2xl">
                          <input
                            id="input-retailer-checkbox"
                            type="checkbox"
                            disabled={isAllUser}
                            checked={isAllInputRetailer}
                            onChange={(e) => {
                              setIsAllInputRetailer(e.target.checked) 
                              e.target.checked ? setSendToError(false) : setSendToError(true)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="input-retailer-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Input Retailers
                          </label>
                        </div>
                        <div className="flex items-center mr-2 text-2xl">
                          <input
                            id="livestock-sp-checkbox"
                            type="checkbox"
                            disabled={isAllUser}
                            checked={isAllLivestockSP}
                            onChange={(e) => {
                              setIsAllLivestockSP(e.target.checked) 
                              e.target.checked ? setSendToError(false) : setSendToError(true)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="livestock-sp-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Livestock Service Provider
                          </label>
                        </div>
                        <div className="flex items-center mr-2 text-2xl col-span-2">
                          <input
                            id="agri_machine-sp-checkbox"
                            type="checkbox"
                            disabled={isAllUser}
                            checked={isAllAgriMachineSP}
                            onChange={(e) => {
                              setIsAllAgriMachineSP(e.target.checked) 
                              e.target.checked ? setSendToError(false) : setSendToError(true)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="agri_machine-sp-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Agri-Machinery Service Provider
                          </label>
                        </div>
                        <div className="flex items-center mr-2 text-2xl">
                          <input
                            id="others-checkbox"
                            type="checkbox"
                            disabled={isAllUser}
                            checked={isAllOthers}
                            onChange={(e) => {
                              setIsAllOthers(e.target.checked) 
                              e.target.checked ? setSendToError(false) : setSendToError(true)}
                            }
                            className="w-5 cursor-pointer h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            htmlFor="others-checkbox"
                            className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300"
                          >
                            All Others
                          </label>
                        </div>
                      </div>
                      {sendToError && <ErrorMessage message={"Please select at least one checkbox."} />}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => handleCategory(false)}
                  >
                    {t("O_BACK")}
                  </button>
                  {addMerchantLoading ? (
                    <div className="spinner-container">
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    <OButton
                      label={<>{t("O_SEND")}</>}
                      type="submit"
                      onClick={handleSubmit(onSubmit,onError)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </>
    </div>
  );
};

export default NotificationAdd;
